import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(1),
  },
  title: {
    fontSize: 14,
    fontWeight: 700,
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(1.5),
  },
  list: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1.5),
  },
  pill: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    padding: theme.spacing(0.75, 1.5),
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 8,
    textDecoration: 'none',
    color: theme.palette.text.primary,
    fontSize: 13,
    fontWeight: 500,
    transition: 'border-color 0.15s, background-color 0.15s',
    '&:hover': {
      borderColor: theme.palette.primary.main,
      backgroundColor: theme.palette.primary.light,
    },
  },
  fileIcon: {
    color: theme.palette.text.secondary,
    flexShrink: 0,
  },
  downloadIcon: {
    color: theme.palette.text.secondary,
    flexShrink: 0,
    marginLeft: theme.spacing(0.5),
  },
}))

export default useStyles
